import { SpokeSummaryCountDto } from "./SpokeStatusDto";

type HubToDoorProps = {

    spokeSummaryCount: SpokeSummaryCountDto;

};

export const HubToDoor : React.FC<HubToDoorProps> = ( { spokeSummaryCount } ) => {

    return (

        <>

            <h2 style={{ textAlign: 'center' }}>Automated check-in</h2>

            <table style={{ height: 150, marginLeft: 'auto', marginRight: 'auto' }} cellSpacing={0} cellPadding={0}>
                <tbody>
                    <tr>
                        
                        <td rowSpan={3}>
                            <div style={{height: '100%', width: 150, border: '2px solid #c4c4c4', borderRadius: 5, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 20 }}>
                                Hub
                            </div>
                        </td>
                    
                        <td style={{textAlign: 'center', verticalAlign: 'bottom', width: 100 }}>
                            <span style={{ fontWeight: 'bold', fontSize: 14, color: 'green' }}>
                                success: {spokeSummaryCount.hubToSpokeSentSuccess}
                            </span>
                        </td>

                        <td rowSpan={3}>
                            <div style={{height: '100%', width: 150, border: '2px solid #c4c4c4', borderRadius: 5, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 20 }}>
                                Spoke
                            </div>
                        </td>

                        <td style={{textAlign: 'center', verticalAlign: 'bottom', width: 100 }}>
                            <span style={{ fontWeight: 'bold', fontSize: 14, color: 'green' }}>
                                success: {spokeSummaryCount.spokeToVisionlineSuccess}
                            </span>
                        </td>
                        
                        
                        <td rowSpan={3}>
                            <div style={{height: '100%', width: 150, border: '2px solid #c4c4c4', borderRadius: 5, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 20 }}>
                                Visionline
                            </div>
                        </td>

                        <td style={{textAlign: 'center', verticalAlign: 'bottom', width: 100 }}>
                            <span style={{ fontWeight: 'bold', fontSize: 14, color: 'green' }}>
                                success: {spokeSummaryCount.visionlineToDoorSuccess}
                            </span>
                        </td>
                        
                        
                        <td rowSpan={3}>
                            <div style={{height: '100%', width: 150, border: '2px solid #c4c4c4', borderRadius: 5, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 20 }}>
                                Door
                            </div>
                        </td>



                    </tr>
                    <tr>
                        <td style={{textAlign: 'center', verticalAlign: 'middle', height: 20 }}>
                            <svg height={20} width={100}>
                                <line x1="0" y1="10" x2="100" y2="10" stroke="#c4c4c4" strokeWidth={2} />
                                <line x1="90" y1="5" x2="100" y2="10" stroke="#c4c4c4" strokeWidth={2} />
                                <line x1="90" y1="15" x2="100" y2="10" stroke="#c4c4c4" strokeWidth={2} />
                            </svg>
                        </td>

                        <td style={{textAlign: 'center', verticalAlign: 'middle', height: 20 }}>
                            <svg height={20} width={100}>
                                <line x1="0" y1="10" x2="100" y2="10" stroke="#c4c4c4" strokeWidth={2} />
                                <line x1="90" y1="5" x2="100" y2="10" stroke="#c4c4c4" strokeWidth={2} />
                                <line x1="90" y1="15" x2="100" y2="10" stroke="#c4c4c4" strokeWidth={2} />
                            </svg>
                        </td>

                        <td style={{textAlign: 'center', verticalAlign: 'middle', height: 20 }}>
                            <svg height={20} width={100}>
                                <line x1="0" y1="10" x2="100" y2="10" stroke="#c4c4c4" strokeWidth={2} />
                                <line x1="90" y1="5" x2="100" y2="10" stroke="#c4c4c4" strokeWidth={2} />
                                <line x1="90" y1="15" x2="100" y2="10" stroke="#c4c4c4" strokeWidth={2} />
                            </svg>
                        </td>

                    </tr>
                    <tr>

                        <td style={{textAlign: 'center', verticalAlign: 'top'  }}>
                            <span style={{ fontWeight: 'bold', fontSize: 14, color: 'blue' }}>
                                pending: {spokeSummaryCount.hubToSpokeSentPending}
                            </span>
                        </td>

                        <td style={{textAlign: 'center', verticalAlign: 'top'  }}>
                            <span style={{ fontWeight: 'bold', fontSize: 14, color: 'blue' }}>
                                pending: {spokeSummaryCount.spokeToVisionlinePending}
                            </span>
                        </td>

                        <td style={{textAlign: 'center', verticalAlign: 'top'  }}>
                            <span style={{ fontWeight: 'bold', fontSize: 14, color: 'blue' }}>
                                pending: {spokeSummaryCount.visionlineToDoorPending}
                            </span>
                        </td>

                    </tr>
                </tbody>
            </table>
        </>


    );


};